import React from 'react';

import { Box } from '@nerdwallet/currency/components/Box';
import { Button } from '@nerdwallet/currency/components/Button';
import { Text } from '@nerdwallet/currency/components/Text';

import { Actions } from '../canopy-flow-state';
import type { Action } from '../canopy-flow-state';

type Props = {
  dispatch: React.Dispatch<Action>;
};

const ErrorIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 9.25636C12.4142 9.25636 12.75 9.59215 12.75 10.0064V13.7564C12.75 14.1706 12.4142 14.5064 12 14.5064C11.5858 14.5064 11.25 14.1706 11.25 13.7564V10.0064C11.25 9.59215 11.5858 9.25636 12 9.25636Z"
      fill="#DE2828"
    />
    <path
      d="M12.75 16.3814C12.75 16.7956 12.4142 17.1314 12 17.1314C11.5858 17.1314 11.25 16.7956 11.25 16.3814C11.25 15.9671 11.5858 15.6314 12 15.6314C12.4142 15.6314 12.75 15.9671 12.75 16.3814Z"
      fill="#DE2828"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3802 4.37341C11.6693 3.87553 12.3883 3.87553 12.6774 4.37341L20.9551 18.6298C21.2454 19.1298 20.8846 19.7564 20.3065 19.7564H3.75113C3.17296 19.7564 2.81221 19.1298 3.10253 18.6298L11.3802 4.37341ZM5.05386 18.2564L12.0288 6.24365L19.0037 18.2564H5.05386Z"
      fill="#DE2828"
    />
  </svg>
);

const NoPolicyDataErrorScreen = ({ dispatch }: Props): React.ReactNode => {
  return (
    <Box>
      <Box marginBottom="4">
        <ErrorIcon />

        <Text component="p">
          It looks like it is taking us longer to link your policy.
        </Text>

        <Text size="x-small" tone="light">
          Try linking again or contact support@nerdwallet.com
        </Text>
      </Box>

      <Box
        display="flex"
        gridGap="3"
        flexDirection={{ mobile: 'column', desktop: 'row' }}
      >
        <Box width="100">
          <Button
            block
            primary
            onClick={() =>
              dispatch({
                type: Actions.CHECK_RATES,
              })
            }
          >
            Try Again
          </Button>
        </Box>

        <Box width="100">
          <Button
            block
            onClick={() =>
              dispatch({
                type: Actions.CONTINUE,
              })
            }
          >
            Do Later
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NoPolicyDataErrorScreen;
